import React from 'react';
import LoginBg from '../../public/images/login_bg.jpg';

export default function LogoBackground () {
    return (
        <div className="thumb">
            <img src={LoginBg} alt="login" className="imgbg" />
        </div>
    );
}